import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-c62eaa64")
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass({
    loadSpinner:true,
  })
}
const _hoisted_2 = {
  key: 0,
  class: "text"
}
const _hoisted_3 = { class: "icon" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MovingIcon = _resolveComponent("MovingIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.text)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.text), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_MovingIcon, {
        autoplay: true,
        loop: true,
        name: "loader_spinner"
      })
    ])
  ]))
}